import { useEffect, useState } from 'react'
import { Descope } from '@descope/react-sdk'
import process from 'process'
import SignPopup from '../../features/SignPopup/SignPopup'
import { Loader } from 'components/Loader'

const DescopeSignIn = (): JSX.Element => {
  const [flowReady, setFlowReady] = useState<boolean>(false)
  const [componentKey, setComponentKey] = useState<number>(0)

  useEffect(() => {
    // increment key on return to page to refresh component
    // this is caused by Antd limitations for content dismissing
    setComponentKey((prev) => prev + 1)
  }, [])

  return (
    <SignPopup footer={flowReady} contactUs={flowReady} showLogo={false}>
      {!flowReady && <Loader.Spinner className="mt-16" />}
      <Descope
        key={componentKey}
        onReady={() => setFlowReady(true)}
        flowId={process.env.REACT_APP_DESCOPE_LOGIN_FLOW_ID ?? ''}
        styleId={process.env.REACT_APP_DESCOPE_STYLE_ID ?? undefined}
      />
    </SignPopup>
  )
}

export default DescopeSignIn
